import * as React from 'react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

import { cn } from '@/lib/core';

interface CheckboxProps {
  id?: string;
  checked?: boolean | 'indeterminate';
  defaultChecked?: boolean | 'indeterminate';
  onCheckedChange?: (checked: boolean | 'indeterminate') => void;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  value?: string;
  error?: boolean;
  className?: string;
  [key: string]: unknown;
}

function Checkbox({ className, error, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      aria-invalid={error ? 'true' : undefined}
      className={cn(
        'group relative size-5 shrink-0 rounded-[2px] border-[0.5px] transition-colors',
        'focus-visible:ring-2 focus-visible:ring-[#848484]/40 focus-visible:ring-offset-1 focus-visible:outline-none',
        // Default (unchecked)
        'border-[#848484] bg-white',
        // Pressed (active, unchecked)
        'active:bg-[#f4f4f4]',
        // Selected (checked)
        'data-[state=checked]:border-transparent data-[state=checked]:bg-[#f4f4f4]',
        // Error
        'aria-invalid:border-[#971b2f]',
        // Disabled
        'data-disabled:cursor-not-allowed data-disabled:border-transparent data-disabled:bg-[#eaeaea]',
        className
      )}
      {...(props as any)}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        <svg
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          aria-hidden="true"
          className="text-[#1a1a1a] group-data-disabled:text-[#a9a9a9]"
        >
          <path
            d="M1 3.5L3.5 6L9 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
